import { components } from "@/api-schema";
import { DEFAULT_PAGE_SIZE } from "@/common/api/_defaults";
import {
  AppRoleGroupSearchParameters,
  AppRoleGroupSearchRequestBody,
  useAppRoleGroupSearchQuery,
} from "@/common/api/app-role/use-app-role-group-search.query";
import { RowWithIdentifier } from "@/components/data-table/_helpers/row-identifier";
import { TableFeatures } from "@/components/data-table/types";
import { createBasePredefinedTable } from "./_components/base-predefined-table";
import {
  BasePredefinedTableProps,
  DataFetchHooks,
  PredefinedTableConfig,
} from "./_components/base-predefined-table.types";
import { groupWithAppRoleTableDefaultColumns } from "./group-with-app-role-table-columns";

type GroupWithAppRole = components["schemas"]["GroupWithAppRoleResponseDto"] & RowWithIdentifier;
type GroupWithAppRoleQueryParams = AppRoleGroupSearchParameters;
type GroupWithAppRoleRequestBody = AppRoleGroupSearchRequestBody;

const DEFAULT_COLUMNS = [groupWithAppRoleTableDefaultColumns.columnName];

const GROUP_WITH_APP_ROLE_TABLE_CONFIG: PredefinedTableConfig<[]> = {
  defaultPageSize: DEFAULT_PAGE_SIZE,
  defaultSorting: [] as const,
  defaultTableConfig: {
    searchPlaceholder: "ram:SearchForGroup",
    features: {
      multiSelection: true,
      pagination: true,
      search: true,
      expansion: false,
    } as TableFeatures,
  } as const,
  defaultRowActions: {
    showEdit: false,
    showView: false,
    showDelete: false,
    showRestore: false,
  } as const,
} as const;

const GROUP_WITH_APP_ROLE_TABLE_QUERY_HOOKS: DataFetchHooks<
  GroupWithAppRole,
  GroupWithAppRoleQueryParams,
  GroupWithAppRoleRequestBody
> = {
  useSearchQuery: useAppRoleGroupSearchQuery,
} as const;

const BaseGroupWithAppRoleTable = createBasePredefinedTable({
  config: GROUP_WITH_APP_ROLE_TABLE_CONFIG,
  queryHooks: GROUP_WITH_APP_ROLE_TABLE_QUERY_HOOKS,
  defaultColumns: DEFAULT_COLUMNS,
});

export interface GroupWithAppRoleTableProps extends BasePredefinedTableProps<
  GroupWithAppRole,
  [],
  GroupWithAppRoleQueryParams,
  GroupWithAppRoleRequestBody
> {}

export function GroupWithAppRoleTable(props: GroupWithAppRoleTableProps) {
  return <BaseGroupWithAppRoleTable name={"group-with-app-role-table"} disableUrlPersistence {...props} />;
}
